import apiClient, { resolveInstitutionId } from './api';
import { toast } from 'react-toastify';

const getStoredToken = () => {
  try {
    const raw = localStorage.getItem('auth-storage');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state?.token || null;
  } catch {
    return null;
  }
};

const setupInterceptors = () => {
  apiClient.interceptors.request.use(
    (config) => {
      let token = null;
      let institutionId = null;

      try {
        const raw = localStorage.getItem('auth-storage');
        if (raw) {
          const parsed = JSON.parse(raw);
          token = parsed?.state?.token;
          institutionId = parsed?.state?.institution?.id;
        }
      } catch (e) {
        // ignore
      }

      if (token) config.headers.Authorization = `Bearer ${token}`;

      if (!institutionId) {
        institutionId = resolveInstitutionId();
      }

      if (institutionId) {
        config.headers['X-INSTITUTION-ID'] = institutionId;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        console.error('API Error Response:', error.response);
        const message = error.response.data?.message || 'An unexpected error occurred.';
        toast.error(`Error: ${message} (Status: ${error.response.status})`);
      } else if (error.request) {
        console.error('API Network Error:', error.request);
        toast.error('Network Error: Could not connect to the server.');
      } else {
        console.error('API Request Setup Error:', error.message);
        toast.error('An error occurred while setting up the request.');
      }
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
